import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Tooltip } from "@mui/joy";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const BodyPartCard = ({ bodyPart, handleOnClick, selectedBodyPart }) => {
  const handleClick = () => {
    handleOnClick(bodyPart); // Pass the bodyPart value to the handleOnClick function
  };
  const borderColor = "#1976d2";
  const storedBodyPart = localStorage.getItem("selectedBodyPart");
  return (
    <Card
      sx={{
        borderRadius: 8,
      }}
    >
      <Tooltip
        title={capitalizeFirstLetter(bodyPart)}
        placement="top"
        variant="solid"
      >
        <CardActionArea
          sx={{
            width: {
              xs: 80,
              sm: 120,
              md: 150,
              lg: 150,
              xl: 200,
            },
            height: {
              xs: 80,
              sm: 120,
              md: 150,
              lg: 150,
              xl: 200,
            },
            border: `3px solid ${
              selectedBodyPart === bodyPart ||
              (!selectedBodyPart && storedBodyPart === bodyPart)
                ? borderColor // Border color when selected
                : "transparent" // Default border color
            }`,
            borderRadius: 8, // Border radius
            padding: 0.5,

            transition: "border-color 0.6s ease", // Add a smooth transition effect
            "&:hover": {
              border: `3px solid ${
                selectedBodyPart === bodyPart ||
                (!selectedBodyPart && storedBodyPart === bodyPart)
                  ? borderColor // Border color on hover when selected
                  : "lightgray" // Default border color on hover
              }`,
            },
          }}
          onClick={() => handleClick(bodyPart)}
        >
          <CardMedia
            component="svg"
            image={`/${bodyPart}.svg`}
            alt={`${bodyPart} image`}
            value={bodyPart}
            sx={{
              objectFit: "contain",
              height: "100%",
              width: "100%",
              color: "purple",
            }}
          />
          <CardContent></CardContent>
        </CardActionArea>
      </Tooltip>
    </Card>
  );
};

const BodyPartCards = ({ handleOnClick, selectedBodyPart }) => {
  const bodyParts = [
    "chest",
    "back",
    "upper legs",
    "shoulders",
    "lower legs",
    "upper arms",
    "waist",
    "bodyweight",
  ];

  const cards = bodyParts.map((bodyPart, index) => (
    <BodyPartCard
      key={bodyPart}
      bodyPart={bodyPart}
      handleOnClick={handleOnClick}
      selectedBodyPart={selectedBodyPart}
    />
  ));

  return (
    <div className="flex flex-col items-center xl:ml-72">
      <div className="flex flex-wrap justify-center gap-3 sm:w-11/12 md:w-9/12 2xl:w-full p-1 mb-4">
        {cards}
      </div>
    </div>
  );
};

export default BodyPartCards;
